import React, { useState, useEffect } from "react";
import styles from "./productDetails.module.css";
import { Closein2, Doc } from "../../../../../Svg";
import { stripHtmlTags } from "../../../../utils/utils";

const ProductDetails = ({ productOverview, category, assets }) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(assets?.image?.[0] || assets?.featuredImage?.[0]);

  useEffect(() => {
    setCurrentImage(assets?.image?.[0] || assets?.featuredImage?.[0]);
  }, [assets]);

  const isImage = (url) => {
    if (!url) return false;
    const path = url.split(/[?#]/)[0];
    return /\.(jpg|jpeg|png|gif|webp|svg|avif|bmp|ico)$/i.test(path);
  };

  const isVideo = (url) => {
    if (!url) return false;
    const path = url.split(/[?#]/)[0];
    return /\.(mp4|webm|ogg|mov|avi)$/i.test(path);
  };

  const displayCategories = React.useMemo(() => {
    if (!category || !Array.isArray(category)) return [];

    const hasFixed = category.some(c => c?.name?.toLowerCase() === "fixed capacitors" || c?.name?.toLowerCase() === "fixed capacitor");
    if (!hasFixed) {
      const isCapacitorCategory = category.some(c => c?.name?.toLowerCase().includes("capacitor"));
      if (isCapacitorCategory) {
        const list = [...category];
        const capIdx = list.findIndex(c => c?.name?.toLowerCase() === "capacitors");
        const fixedObj = { _id: "Fixed Capacitors", name: "Fixed Capacitors" };
        if (capIdx !== -1) {
          list.splice(capIdx + 1, 0, fixedObj);
        } else {
          list.splice(1, 0, fixedObj);
        }
        return list;
      }
    }
    return category;
  }, [category]);

  const safeAssets = assets && typeof assets === "object" ? assets : {};
  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  const seenUrls = new Set();
  const seenUrlsPopup = new Set();

  return (
    <>
      {(assets?.featuredImage?.length > 0 || assets?.image?.length > 0 || assets?.video?.length > 0) &&
        <div className={styles.prodDetailImg} >
          {isImage(currentImage) ? (
            <img src={currentImage} alt="Main Product" className={styles.mainImg} onClick={openPopup} />
          ) : isVideo(currentImage) ? (
            <video
              width={'300'}
              controls
              style={{ margin: "5px", cursor: "pointer" }}
            >
              <source src={currentImage} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : null}
          <div className={styles.thumbnailImages}>
            {Object.entries(safeAssets).map(([key, values]) => {
              if (!Array.isArray(values)) return null;
              return values.map((item, index) => {
                if (!item || seenUrls.has(item)) return null;
                seenUrls.add(item);
                return (
                  <div
                    key={`${key}-${index}`}
                    className={`${styles.box1}`}
                    onClick={() => setCurrentImage(item)}
                  >
                    {key === "image" || key === "featuredImage" ? (
                      <img
                        src={item}
                        alt={`${key}-${index}`}
                        style={{
                          width: "80px",
                          height: "80px",
                          margin: "5px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          objectFit: "cover",
                          border: currentImage === item ? "2px solid #512DA8" : "2px solid transparent"
                        }}
                      />
                    ) : key === "video" ? (
                      <video
                        width="80"
                        height="80"
                        style={{
                          margin: "5px",
                          cursor: "pointer",
                          borderRadius: "6px",
                          objectFit: "cover",
                          border: currentImage === item ? "2px solid #512DA8" : "2px solid transparent"
                        }}
                      >
                        <source src={item} type="video/mp4" />
                      </video>
                    ) : null}
                  </div>
                );
              });
            })}
          </div>
        </div>
      }
      {isPopupOpen && (
        <div className={styles.popupOverlay} onClick={closePopup}>
          <div
            className={styles.popupContainer}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.prodDetailImgpopup}>
              <div className={styles.cancle}>
                <h4 className={styles.text1}>Images</h4>
                <span className={styles.closeButton} onClick={closePopup}>
                  <Closein2 />
                </span>
              </div>
              {isImage(currentImage) ? (
                <img
                  src={currentImage}
                  alt="Popup Product"
                  className={styles.popupImage}
                />
              ) : isVideo(currentImage) ? (
                <video
                  width={'300'}
                  controls
                  style={{ margin: "5px", cursor: "pointer" }}
                >
                  <source src={currentImage} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : null}
              <div className={styles.thumbnailImagespopup}>
                {Object.entries(safeAssets).map(([key, values]) => {
                  if (!Array.isArray(values)) return null;
                  return values.map((item, index) => {
                    if (!item || seenUrlsPopup.has(item)) return null;
                    seenUrlsPopup.add(item);
                    return (
                      <div
                        key={`${key}-${index}`}
                        className={styles.box1}
                        onClick={() => setCurrentImage(item)}
                      >
                        {key === "image" || key === "featuredImage" ? (
                          <img
                            src={item}
                            alt={`${key}-${index}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              margin: "5px",
                              cursor: "pointer",
                              borderRadius: "6px",
                              objectFit: "cover",
                              border: currentImage === item ? "2px solid #512DA8" : "2px solid transparent"
                            }}
                          />
                        ) : key === "video" ? (
                          <video
                            width="80"
                            height="80"
                            style={{
                              margin: "5px",
                              cursor: "pointer",
                              borderRadius: "6px",
                              objectFit: "cover",
                              border: currentImage === item ? "2px solid #512DA8" : "2px solid transparent"
                            }}
                          >
                            <source src={item} type="video/mp4" />
                          </video>
                        ) : null}
                      </div>
                    );
                  });
                })}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className={styles.prodDetailContent}>
        <h2 className={styles.productTitle}>{productOverview?.productNumber?.[0] || ''}</h2>
        <ul className={styles.productInfo}>
          <li>
            <div style={{ width: '26%' }}>Manufacturer </div>
            <div style={{ width: '74%' }}>{productOverview?.manufacturer?.[0]?.name || ''}</div>
          </li>
          <li>
            <div style={{ width: '26%' }}>Category </div>
            <div style={{ width: '74%' }}>{displayCategories?.map((cat, index) => index === displayCategories?.length - 1 ? cat?.name : cat?.name + ', ')}</div>
          </li>
          <li>
            <div style={{ width: '26%' }}>Description </div>
            <div style={{ width: '74%' }}>{stripHtmlTags(productOverview?.description)}</div>
          </li>
          <li>
            <div style={{ width: '26%' }}>Manufacturer lead time</div>
            <div style={{ width: '74%' }}>{productOverview?.manufactureLeadTime?.[0]}</div>
          </li>
          <li>
            <div style={{ width: '26%', paddingTop: '8px' }}>Data Sheet
            </div>
            <div style={{ width: '74%' }}>
              {productOverview?.datasheetUrl?.[0] ? (
                <a href={productOverview.datasheetUrl[0]} target="_blank" rel="noreferrer" className={styles.dataSheetLink}>
                  Data sheet <Doc />
                </a>
              ) : (
                <span>N/A</span>
              )}
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ProductDetails;
